import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/apiClient";

export default function AuditPage() {
  const [logs, setLogs] = useState([]);

  const load = useCallback(async () => {
    const r = await api.get("/audit");
    setLogs(r.data);
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="p-8 space-y-6">
      <div>
        <div className="data-label mb-1">Compliance & traceability</div>
        <h1 className="font-heading font-black text-4xl tracking-tight">Audit log</h1>
      </div>
      <div className="card-shell overflow-hidden">
        <table className="data-table">
          <thead>
            <tr>
              <th>When</th><th>Actor</th><th>Action</th><th>Record</th><th>Meta</th>
            </tr>
          </thead>
          <tbody data-testid="audit-tbody">
            {logs.map((l) => (
              <tr key={l.id} data-testid={`audit-row-${l.id}`}>
                <td className="text-xs text-[#71717A] whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</td>
                <td className="text-xs font-mono">{l.actor_email || "system"}</td>
                <td className="text-xs font-mono">{l.action}</td>
                <td className="text-xs font-mono">{l.record_id?.slice(0, 8)}…</td>
                <td className="text-xs text-[#52525B] font-mono">{JSON.stringify(l.meta || {})}</td>
              </tr>
            ))}
            {logs.length === 0 && (
              <tr><td colSpan="5" className="text-center text-[#71717A] p-8">No audit entries yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
